import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "m14.039 0 1.051 8.931-1.179.139-.938-7.976H3.029L2.091 9.07.912 8.931 1.963 0zM4 2h8v1H4zm0 2h8v1H4zm0 2h8v1H4zm0 2h8v1H4zm11.5 2H.5c-.275 0-.429.213-.342.474l1.684 5.051a.74.74 0 0 0 .658.474h11a.74.74 0 0 0 .658-.474l1.684-5.051c.087-.261-.067-.474-.342-.474M10 12H6v-1h4z" }, null, -1)
  ]))]))
}
export default { render: render }